import React from 'react';
import { List } from '@mui/material';
import NavigationItem from './NavigationItem';
import { NAVIGATION_ITEMS } from '../../../config/constants';
import { useNavigationPermissions } from '../hooks/useNavigationPermissions';

/**
 * NavigationList Component
 *
 * Renders the main list of navigation items in the expanded navigation drawer.
 * Maps through all navigation items and renders them using NavigationItem components.
 * Filters items based on user permissions (hides Settings for non-admin users).
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isActive - Function to check if a path is active
 * @param {boolean} props.isExpanded - Function to check if an item is expanded
 * @param {boolean} props.showDescription - Whether to show item descriptions
 * @param {Function} props.onItemClick - Callback for main item click
 * @param {Function} props.onSubItemClick - Callback for sub-item click
 */
const NavigationList = ({
  isActive,
  isExpanded,
  showDescription,
  onItemClick,
  onSubItemClick,
}) => {
  // Filter navigation items based on user permissions
  const { visibleItems } = useNavigationPermissions(NAVIGATION_ITEMS);

  return (
    <List sx={{ px: 1 }}>
      {visibleItems.map(item => (
        <NavigationItem
          key={item.id}
          item={item}
          isActive={isActive(item.path)}
          isExpanded={isExpanded(item.id)}
          showDescription={showDescription}
          onItemClick={onItemClick}
          onSubItemClick={onSubItemClick}
          isSubItemActive={isActive}
        />
      ))}
    </List>
  );
};

export default NavigationList;
